import React, {useContext, useEffect, useReducer} from 'react';
import reducer from './reducer';

const AppContext = React.createContext();

const initialState = {
  departureLocations: [],
  isLoadingDepartures: true,
  departureLocation: 'Le Marais',
  tripList: [],
  isLoadingTripList: false,
  journeySelected: {},
  isLoadingReservation: false,
  booked: {}
}

const AppProvider = ({children})=>{
    const baseUrl = 'https://6130d11c8066ca0017fdaa97.mockapi.io/'
    const [state, dispatch] = useReducer(reducer, initialState)

    const fetchDepartureLocations = () => {
      fetch(`${baseUrl}/stops`)
        .then(response => response.json())
        .then(data => dispatch({type: 'SET_DEPARTURE_LOCATIONS', payload: data}))
        .catch(error => console.log(error));
    }

    const fetchTripList = (searchTerm) => {
      dispatch({type: 'SET_TRIP_IS_LOADING_LIST'});
      fetch(`${baseUrl}/trips?departureStop=${searchTerm}`)
        .then(response => response.json())
        .then(data => dispatch({type: 'SET_TRIP_LIST', payload: data}))
        .catch(error => console.log(error));
    }

    const sendReservation = (trip) => {
      dispatch({type: 'SET_LOADING_RESERVATION'});
      fetch(`${baseUrl}/book/${trip.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => response.json())
        .then(data => dispatch({type: 'SET_BOOKED_TRIP', payload: {status: data, trip: trip}}))
        .catch(error => console.log(error));
    }

    useEffect(() => {
      fetchDepartureLocations()
    }, [])

    useEffect(() => {
      fetchTripList(state.departureLocation)
    }, [state.departureLocation])

    const setDepartureLocation = (destination) => {
      dispatch({type: 'SET_DEPARTURE_LOCATION', payload: destination})
    }

    const setTrip = (trip) => {
      dispatch({type: 'SET_TRIP', payload: trip})
    }

    return (<AppContext.Provider value={{
        ...state,
        setDepartureLocation,
        setTrip,
        sendReservation
    }}>
        {children}
    </AppContext.Provider>
)}

export const useGlobalContext = ()=>{
    return useContext(AppContext)
}

export {AppContext, AppProvider}
